// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".NotificationsButton {\n  position: relative;\n}", "",{"version":3,"sources":["webpack://./components/NotificationsButton/index.sass"],"names":[],"mappings":"AAEA;EACE,kBAAA;AADF","sourcesContent":["@import \"style/mixins.sass\"\n\n.NotificationsButton\n  position: relative\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
